// extracted by mini-css-extract-plugin
export default {"emptyList":"EmptyList_emptyList__Harir","button":"EmptyList_button__eIfZy"};